module.exports = __webpack_public_path__ + "static/media/background.af46c278.jpg";